// import React from 'react';
// import { FaPlus } from "react-icons/fa6";

// const Gallery = () => {
//     return (
//         <div>
//             <section className="boldSection bottomSemiSpaced btPageHeadline gutter topSemiSpaced btTextLeft wBackground cover btParallax btDarkSkin btBackgroundOverlay btSolidDarkBackground"
//                 style={{ backgroundColor: "#142340", backgroundImage: `url("https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/09/hero_inner_page.jpg")`, backgroundPosition: "50% 40.6451px", dataParallax: "0.8", dataParallaxOffset: "0" }}>
//                 <div className="port">
//                     <header className="header btClear large">
//                         <div className="btSuperTitle">
//                             <span>
//                                 <div className="btBreadCrumbs">
//                                     <nav>
//                                         <ul>
//                                             <li><a href="/">Home</a></li>
//                                             <li><a href="#">Gallery</a></li>
//                                         </ul>
//                                     </nav>
//                                 </div>
//                             </span>
//                         </div>
//                         <div className="dash">
//                             <h2><span className="headline">Gallery</span></h2>
//                         </div>
//                         <div className="btSubTitle">"Explore our gallery filled with captivating images showcasing our latest projects, events, and achievements. Get inspired and see the quality of our work firsthand."</div>
//                     </header>
//                 </div>
//             </section>
//             <section style={{ marginLeft: "190px" }}>
//                 <div className="boldRow boldRow topSmallSpaced bottomSmallSpaced">
//                     <div className="rowItem col-sm-12 btTextCenter btGridGap5">
//                         <div className="btMediaBox">
//                             <div className="tilesWall btGridGallery tiled btGridGap-20" data-col="4" style={{ position: "relative", height: "580px" }}>
//                                 <div className="gridSizer" style={{ width: "290px", height: "0px" }}></div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="1" style={{ opacity: "1", position: "absolute", left: "0px", top: "0px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage ">
//                                                         <img className='zoomable-image' 

//                                                        
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="2" style={{ opacity: "1", position: "absolute", left: "290px", top: "0px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage">
//                                                        
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="3" style={{ opacity: "1", position: "absolute", left: "580px", top: "0px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage">
//                                                      
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="4" style={{ opacity: "1", position: "absolute", left: "870px", top: "0px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage">
//                                                    
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="5" style={{ opacity: "1", position: "absolute", left: "0px", top: "290px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage">
//                                                         <img style={{ height: "300px" }} src="./Images/g2.jpeg" alt="" title="Your Image Title" />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="6" style={{ opacity: "1", position: "absolute", left: "290px", top: "290px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage" >
//                                                         <img style={{ height: "300px" }} src="./Images/g11.jpeg" alt="" title="Your Image Title" />
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="7" style={{ opacity: "1", position: "absolute", left: "580px", top: "290px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage">
//                                                       
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>


//                                     {/* Add more grid items here */}
//                                 </div>
//                                 <div className="gridItem btGhostSliderThumb bt11" data-order-num="8" style={{ opacity: "1", position: "absolute", left: "870px", top: "290px", width: "290px", height: "290px" }}>
//                                     <div className="btTileBox">
//                                         <div className="bpgPhoto">
//                                             <a href="#"></a>
//                                             <div className="boldPhotoBox">
//                                                 <div className="bpbItem">
//                                                     <div className="btImage">
//                                                       
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="captionPane btDarkSkin btTextCenter">
//                                                 <div className="captionTable">
//                                                     <div className="">
//                                                         <div className="captionTxt">
//                                                             <header className="" >

//                                                                 <div className="" style={{ marginTop: "130px" }}>

//                                                                 </div>
//                                                             </header>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>


//                                         </div>
//                                     </div>
//                                 </div>


//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </div>
//     );
// }

// export default Gallery;
import React, { useEffect } from 'react';
import { FaPlus } from "react-icons/fa6";
import "./Gallery.css";

const Gallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  return (
    <div>
      <section
        className="boldSection bottomSemiSpaced btPageHeadline gutter topSemiSpaced btTextLeft wBackground cover btParallax btDarkSkin btBackgroundOverlay btSolidDarkBackground"
        style={{
          backgroundColor: "#142340",
          backgroundImage: `url("https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/09/hero_inner_page.jpg")`,
          backgroundPosition: "50% 40.6451px",
          dataParallax: "0.8",
          dataParallaxOffset: "0",
        }}
      >
        <div className="port">
          <header className="header btClear large">
            <div className="btSuperTitle">
              <span>
                <div className="btBreadCrumbs">
                  <nav>
                    <ul>
                      <li>
                        <a href="/">Home</a>
                      </li>
                      <li>
                        <a href="#">Gallery</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </span>
            </div>
            <div className="dash">
              <h2>
                <span className="headline">Gallery</span>
              </h2>
            </div>
            <div className="btSubTitle">
              "Explore our gallery filled with captivating images showcasing our
              latest projects, events, and achievements. Get inspired and see
              the quality of our work firsthand."
            </div>
          </header>
        </div>
      </section>

      <div class="container_dd">
        <h1 class="heading_dd"></h1>

        <div class="gallery">
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/fs3.png"
              alt="person writing in a notebook beside by an iPad, laptop, printed photos, spectacles, and a cup of coffee on a saucer"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g1.jpeg"
              alt="sunset behind San Francisco city skyline"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/ps15.jpg"
              alt="people holding umbrellas on a busy street at night lit by street lights and illuminated signs in Tokyo, Japan"
            />
          </div>



          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g10.jpeg"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>


          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/pc12.jpg"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g2.jpeg"
              alt="back view of woman wearing a backpack and beanie waiting to cross the road on a busy street at night in New York City, USA"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g3.jpeg"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g11.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g12.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g13.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g14.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="./Images/g15.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>


        </div>
      </div>
    </div>
  );
};

export default Gallery;